export const openNewTab = (url?: string) => {
  if (url) {
    window.open(url, '_blank');
  }
};
